import { createUseStyles, ComposedTheme } from '@glu/theming';

const styles = ({ spacing: { unit } }: ComposedTheme) => ({
  // The FDIC has very specific size and color requirement for the logo and text.
  // The size requirements dictate the decimals in the pixel size for the image and font size.
  fdicLogo: {
    width: 37.36,
    height: 15.74,
    marginRight: 1 * unit
  },
  fdicContainer: {
    fontFamily: '"Source Sans 3", sans-serif',
    fontSize: '12.8px',
    fontWeight: 400,
    fontStyle: 'italic',
    display: 'flex',
    alignItems: 'flex-start',
    '& span': {
      minHeight: 15.74
    }
  },
  light: {
    color: '#ffffff'
  },
  dark: {
    color: '#000000'
  }
});

export default createUseStyles(styles);
